var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "Report__Entity" },
    [
      _c("Entity", {
        ref: "entity",
        attrs: {
          "entity-type": "user",
          "entity-id": _vm.userId,
          isEntityPage: _vm.isEntityPage,
          showRelations: true,
          innerComponent: _vm.innerComponent,
          innerComponentTitle: "פרטי איש קשר",
          title: "איש קשר",
          "back-button-text": "רשימת משתמשים",
          "back-button-url": !_vm.isCourse ? "users" : "admin/users",
          widgets: _vm.widgets,
          actions: _vm.actions,
          preview: _vm.preview,
          "read-only": _vm.readOnly,
          entityReady: _vm.entityReady,
          activities: [],
        },
        on: { onFormSave: _vm.onFormSave, onFormDiscard: _vm.onFormDiscard },
        scopedSlots: _vm._u([
          {
            key: "mandatory",
            fn: function () {
              return [
                _c(
                  "div",
                  {
                    staticClass:
                      "Accident__Entity__Details__BaseDetails__Stage",
                  },
                  [
                    _c("span", { staticClass: "ltr" }, [
                      _vm._v("הפניה לסימולטור:"),
                    ]),
                    _c(
                      "span",
                      {
                        staticClass:
                          "Accident__Entity__Details__BaseDetails__Stage__Value value has-text-weight-bold link",
                        on: { click: _vm.openSimulator },
                      },
                      [_vm._v("קישור")]
                    ),
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass:
                      "Accident__Entity__Details__BaseDetails__Stage",
                  },
                  [
                    _c("span", [
                      _vm._v("מזהה התלמיד: "),
                      _c("strong", [_vm._v(_vm._s(_vm.userId))]),
                    ]),
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass:
                      "Accident__Entity__Details__BaseDetails__Stage",
                  },
                  [
                    _c("span", { staticClass: "ltr" }, [
                      _vm._v("בחר קורס להורדת JSON: "),
                    ]),
                    _c(
                      "b-select",
                      {
                        staticClass:
                          "Accident__Entity__Details__BaseDetails__Stage__Value",
                        attrs: { size: "is-small" },
                        model: {
                          value: _vm.downloadCourseId,
                          callback: function ($$v) {
                            _vm.downloadCourseId = $$v
                          },
                          expression: "downloadCourseId",
                        },
                      },
                      [
                        _c(
                          "option",
                          {
                            attrs: { disabled: "" },
                            domProps: { value: null },
                          },
                          [_vm._v("בחר קורס")]
                        ),
                        _vm._l(_vm.userCourses, function (course) {
                          return _c(
                            "option",
                            { key: course.id, domProps: { value: course.id } },
                            [_vm._v(_vm._s(course.courseName))]
                          )
                        }),
                      ],
                      2
                    ),
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass:
                      "Accident__Entity__Details__BaseDetails__Stage",
                  },
                  [
                    _c("span", { staticClass: "ltr" }, [
                      _vm._v("הורדה של קובץ ה JSON העדכני שנשלח: "),
                    ]),
                    _c(
                      "span",
                      {
                        staticClass:
                          "Accident__Entity__Details__BaseDetails__Stage__Value value has-text-weight-bold link",
                        on: { click: _vm.downloadSentSchedule },
                      },
                      [_vm._v("קישור")]
                    ),
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass:
                      "Accident__Entity__Details__BaseDetails__Stage",
                  },
                  [
                    _c("span", { staticClass: "ltr" }, [
                      _vm._v("הורדה של קובץ ה JSON העדכני שהתקבל: "),
                    ]),
                    _c(
                      "span",
                      {
                        staticClass:
                          "Accident__Entity__Details__BaseDetails__Stage__Value value has-text-weight-bold link",
                        on: { click: _vm.downloadReceivedSchedule },
                      },
                      [_vm._v("קישור")]
                    ),
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass:
                      "Accident__Entity__Details__BaseDetails__Stage",
                    staticStyle: { display: "flex", "align-items": "center" },
                  },
                  [
                    _c("span", {}, [_vm._v("איפוס סיסמה לתלמיד:")]),
                    _c(
                      "b-button",
                      {
                        staticClass:
                          "Accident__Entity__Details__BaseDetails__Stage__Value value has-text-weight-bold",
                        attrs: { loading: _vm.isLoading },
                        on: { click: _vm.resetStudentPassword },
                      },
                      [_vm._v("איפוס")]
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }